import { render, staticRenderFns } from "./AccountSwitcher.vue?vue&type=template&id=01adaeda&scoped=true"
import script from "./AccountSwitcher.vue?vue&type=script&lang=js"
export * from "./AccountSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AccountSwitcher.vue?vue&type=style&index=0&id=01adaeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01adaeda",
  null
  
)

export default component.exports